<!--
* UIID: UI-DLB-SRM-110
* UI Name: EDI Analyzed View
* Modify Date: 2020/04/16
-->
<template>
  <v-card class="v-modal-new-window analyzed-dialog analyzed-view-dialog">
    <!-- [S]  Popup title-->
    <v-card-title class="headline white--text" primary-title>{{ pageTitle }}</v-card-title>
    <!-- [E]  Popup title-->
    <div class="edi-analyzed-container">
      <!-- [S]  Info-->
      <v-card-text class="srm-info-section">
        <v-row>
          <v-col cols="12" sm="3" class="pt-0 padding-bottom-10">
            <span class="float-left">
              <span class="subheader-text"
                >{{ this.params.STR_SNDR }} - {{ this.params.STR_RCVR }} -</span
              >
              <span class="subheader-message">{{ this.params.MSG_ID }}</span>
            </span>
          </v-col>
          <v-col cols="12" sm="9" class="pt-0 padding-bottom-10">
            <span class="float-left">
              <span class="gridheader-text">Layout View</span>
            </span>
            <span class="float-right" v-if="this.mode != 'RepositoryLayoutView'">
              <span class="gridheader-text">Total analyzed EDI File :</span>
              <span class="total-text">{{ this.params.MSG_CNT }}</span>
            </span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Info-->

      <v-card-text class="data-section-srm">
        <!-- [S]  Tree view and table-->
        <v-row class="ma-0 edi-data-mb">
          <v-col cols="12" class="pt-0 pb-0 pd-grid-left">
            <v-row>
              <!-- [S]  Tree view-->
              <v-col cols="12" sm="3" class="pt-0 pb-0 tree-container">
                <v-row class="tree-panel wrap-content-left mr-0">
                  <v-col cols="12" class="text-left pa-0 pr-3 pb-2">
                    <v-btn
                      x-small
                      tile
                      @click="expandAllTreeView"
                      class="expand-all-tree-view-button"
                      dark
                      >{{ !expandAll ? 'Expand All' : 'Collapse All' }}</v-btn
                    >
                  </v-col>
                  <v-col cols="12" class="pb-1 col-tree">
                    <!-- <v-row>
                    <v-col cols="2">
                        <v-text-field v-model="segmentFilterValue" type="text" label="Segment"></v-text-field>           
                    </v-col>
                    </v-row>-->
                    <v-row class="no-gutters">
                      <v-treeview
                        :open="open"
                        :items="treeItems"
                        ref="analyzedTreeView"
                        v-model="tree"
                        activatable
                        open-on-click
                        class="analyzedTree"
                      >
                        <template v-slot:label="{ item }">
                          <div
                            v-if="!item.disabled && typeof item.children != 'undefined'"
                            class="group-has-children-item"
                          >
                            <v-icon small class="mr-1">fa fa-object-group</v-icon>
                            <span class="group-name">{{ item.seg }}</span>
                            - {{ item.req }} - {{ item.loop }}
                          </div>
                          <div
                            v-if="item.disabled && typeof item.children != 'undefined'"
                            class="group-no-children-item"
                          >
                            <v-icon small color="#b9bbb7" class="mr-1">fa fa-object-group</v-icon>
                            <span class="group-name">{{ item.seg }}</span>
                            - {{ item.req }} - {{ item.loop }}
                          </div>
                          <div
                            v-if="typeof item.children == 'undefined' && !item.disabled"
                            class="child-visible-item"
                            @click="itemClick(item)"
                          >
                            <v-icon small class="mr-1">fa fa-cube</v-icon>
                            <span class="child-item">{{ item.seg }}</span>
                            - {{ item.req }} - {{ item.loop }} - {{ item.dataname }}
                          </div>
                          <div
                            v-if="typeof item.children == 'undefined' && item.disabled"
                            class="child-invisible-item"
                          >
                            <v-icon small color="#dbd7db" class="mr-1">fa fa-cube</v-icon>
                            <span class="child-item">{{ item.seg }}</span>
                            - {{ item.req }} - {{ item.loop }} - {{ item.dataname }}
                          </div>
                        </template>
                      </v-treeview>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <!-- [E]  Tree view-->

              <!-- [S]  Table-->
              <v-col cols="12" sm="9" class="pt-0 pl-0 pb-0">
                <v-row class="table-panel wrap-content-right ml-0">
                  <v-col class="pa-0" cols="12">
                    <v-row class="src-topTool ma-0">
                      <v-col cols="12" sm="3" class="text-left pa-0">
                        <div class="pt-0 pb-0">
                          <v-icon :disabled="gridListViewBtn" @click="changeView">fas fa-th</v-icon>
                          <span class="vertical-line"></span>
                          <v-icon :disabled="!gridListViewBtn" @click="changeView"
                            >fa-th-list</v-icon
                          >
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" class="text-right pa-0">
                        <div class="pt-0">
                          <span class="filter-text">Not Used</span>
                          <toggle-button
                            v-model="filterQuery.not_used"
                            :labels="true"
                            :sync="true"
                            @change="toggleFilter"
                            :height="15"
                            :color="{
                              checked: this.checkedColor,
                              unchecked: unCheckedColor,
                              disabled: '#CCCCCC',
                            }"
                            :switch-color="{
                              checked: this.toggleButton,
                              unchecked: this.toggleButton,
                            }"
                          />
                          <!-- <span class="filter-text">One Value</span>
                        <toggle-button v-model="filterQuery.one_value" :labels="true" :sync="true" @change="toggleFilter" :height="15"
                        :color="{checked: this.checkedColor, unchecked: unCheckedColor, disabled: '#CCCCCC'}"
                          :switch-color="{checked: this.toggleButton, unchecked: this.toggleButton}"/>-->
                          <span class="filter-text">Qualifier</span>
                          <toggle-button
                            v-model="filterQuery.qualifier"
                            :labels="true"
                            :sync="true"
                            @change="toggleFilter"
                            :height="15"
                            :color="{
                              checked: this.checkedColor,
                              unchecked: unCheckedColor,
                              disabled: '#CCCCCC',
                            }"
                            :switch-color="{
                              checked: this.toggleButton,
                              unchecked: this.toggleButton,
                            }"
                          />
                        </div>
                      </v-col>
                      <v-col cols="12" sm="3" class="pa-0">
                        <v-text-field
                          placeholder="Search"
                          append-icon="fas fa-search"
                          outlined
                          height="30"
                          dense
                          solo
                          hide-details
                          @input="onFilterAnalyzed"
                          class="search-matched-map-list-button custom-form-component search-button"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="pa-0 pb-0" cols="12" sm="12">
                    <v-table
                      ref="srm_edi_analyzed_table"
                      is-horizontal-resize
                      row-hover-color="#eee"
                      row-click-color="#edf7ff"
                      :height="530"
                      :isMinHeight="isMinHeight"
                      :table-bg-color="'#fafcff'"
                      :title-rows="titleRows"
                      :columns="columns"
                      :table-data="segTableItems"
                      :column-cell-class-name="columnCellClass"
                      :errorContent="'No matching records found'"
                      :is-loading="showLoading"
                      :lazy-loading="lazy_loading"
                      class="analyzed-view-table"
                    ></v-table>
                  </v-col>
                </v-row>
              </v-col>
              <!-- [E]  Table-->
            </v-row>
          </v-col>
        </v-row>
        <!-- [E]  Tree view and table-->

        <v-form ref="form">
          <!-- [S]  Buttons-->
          <v-row class="ma-0 pd-height group-btn-hd">
            <v-col class="pa-0" cols="12" sm="3"></v-col>
            <v-col class="pa-0" cols="12" sm="9">
              <v-row class="ma-0">
                <v-col class="pa-0 display-flex btn-bar" cols="12" sm="5">
                  <v-label>FlatFile layout:</v-label>
                  <div
                    class="flatfile-input flatfile-layout-hd"
                    :class="[isValidF ? 'focusField' : '']"
                  >
                    <v-text-field
                      type="text"
                      solo
                      readonly
                      v-model="flatFileName"
                      class="input-fl input-content"
                      :rules="[validationUtils.required]"
                    ></v-text-field>
                  </div>
                  <div class="dv-select-ffType">
                    <v-select solo v-model="ffType" :items="flatFileType"></v-select>
                  </div>
                  <div class="dv-select-edi">
                    <v-select solo v-model="mapType" :items="mapConVersionType"></v-select>
                  </div>
                  <v-btn class="btn-browse btn-search primary" @click="openFlatFileLayoutList"
                    >Load</v-btn
                  >
                </v-col>
                <v-col cols="12" sm="7" class="pa-0">
                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0"></v-col>
                    <v-col cols="12" sm="12" class="display-flex btn-bar row-pl-16 pa-0 pl-2">
                      <v-label>Map Name:</v-label>
                      <div class="flatfile-input map-name-hd mr-1">
                        <v-text-field
                          type="text"
                          solo
                          v-model="mapName"
                          ref="mapRef"
                          class="input-fl input-content"
                          :rules="[validationUtils.required]"
                          :class="[isValidM ? 'focusField' : '']"
                        ></v-text-field>
                      </div>
                      <v-label>Message:</v-label>
                      <v-autocomplete
                        v-model="messageType"
                        :items="EDIMesList"
                        :menu-props="{ offsetY: true }"
                        :rules="[validationUtils.required]"
                        class="dv-select-ffType mr-1 ml-1"
                        dense
                        solo
                      >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.value }}
                        </template>
                      </v-autocomplete>
                      <v-btn class="btn btn-search" color="primary" tile dark @click="generateMap">
                        <v-icon small color="white" class="mr-1">fa fa-magic</v-icon>Generate Map
                      </v-btn>
                      <v-btn
                        class="btn-style btn-delete"
                        tile
                        dark
                        @click="closeWindow('btn-close')"
                      >
                        <v-icon small color="white" class="mr-1">fa fa-times</v-icon>Close
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <!-- [E]  Buttons-->
      </v-card-text>
    </div>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <flatFile-layout-list-dialog
        v-if="dialog.type == 'flatFileLayoutList'"
        class="custom-dialog flatfile-layout-list"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :selectFile="loadFlatFile"
        :dragEnd="dialogDragEnd"
        :fileSelected="flatFileName"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
      ></flatFile-layout-list-dialog>
    </div>
    <dialogWindow
      ref="confirmDialog"
      size="max"
      title="Confirmation"
      :detail="$t('msg.customerDataAnalysis.ediAnalyzedViewPop.confirmChangeNewMapper')"
      color="confirmation"
      :showCancel="true"
      @select-ok="comfimedChange"
    ></dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      :detail="$t('msg.common.success.detail', ['Mappper', 'created'])"
      @select-ok="closeWindow('btn-close')"
    ></dialogWindow>
  </v-card>
</template>

<script>
/* globals Store */
import { mapState } from 'vuex';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { MsgTreeParser } from '@/vue-dlb/utils/msgtree_parser';
import $ from 'jquery';
import flatFileLayoutListDialog from '@/vue-dlb/views/srm/FlatfilelayoutList.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

const msgtreeParser = new MsgTreeParser();

/* Remove unuse code 
import {  
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress
} from "@/vue-dlb/utils/sys-util.js"; 
import { debounce } from "lodash";
import { get } from "lodash";
*/
export default {
  components: {
    flatFileLayoutListDialog,
    dialogWindow,
  },
  data() {
    return {
      pageTitle: 'EDI Analyzed View',
      head_title: '',
      dataFlatFile: '',
      flatFile: '',
      flatFileName: '',
      dataMap: '',
      mapName: '',
      dataMType: '',
      dataFFType: '',
      mapType: 'E2F',
      ffType: 'Prefix',
      messageType: '',
      isChange: '',
      contenInput: '',
      isValidF: false,
      isValidM: false,
      gridListViewBtn: false,
      // switch_used: false,
      // switch_text: false,
      // switch_must: false,
      lazy_loading: true,
      isMinHeight: true,
      checkedColor: '#75C7AF',
      unCheckedColor: '#BFCBD9',
      toggleButton: '#FFFFFF',
      findFilterValue: '',
      segmentFilterValue: '',
      mapConVersionType: ['E2F', 'F2E'],
      flatFileType: ['Prefix', 'FixedLength'],
      EDIMesList: [{ text: 'Type', value: '' }],
      tree: [],
      treeItems: [],
      arrLayoutDialog: [],
      dialogs: [],
      filterQuery: {
        not_used: false,
        // one_value : false,
        qualifier: false,
      },
      numberFormatter: new Intl.NumberFormat('en-US'),
      expandAll: false,
      dialog: false,
      showLoading: false,
      query: '',
      open: ['ROOT'],
      masterSearchItems: {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
          },
        ],
      },
      searchMessageItems: {
        header: [
          'CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'LAY_PRCS_NO',
          'ALIAS',
        ],
        data: [
          {
            CUST_ID: '',
            STR_SNDR: '',
            STR_RCVR: '',
            MSG_ID: '',
            MSG_VER: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PRCS_STS: '', // in case of DataAnalysis Tree selects all status data
            LAY_PRCS_NO: '',
            ALIAS: '',
          },
        ],
      },
      searchLayoutItems: {
        header: ['MSG_ID', 'MSG_VER', 'LAY_PRCS_NO'],
        data: [
          {
            MSG_ID: '',
            MSG_VER: '',
            LAY_PRCS_NO: '',
          },
        ],
      },
      insertLayoutMaster: {
        header: [
          'CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_STD',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'LAY_PRCS_NO',
        ],
        data: [
          {
            CUST_ID: '',
            STR_SNDR: '',
            STR_RCVR: '',
            MSG_STD: '',
            MSG_ID: '',
            MSG_VER: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PRCS_STS: '',
            LAY_PRCS_NO: '',
          },
        ],
      },
      generateMapDataHeader: {
        header: [
          'CUST_ID',
          'OWNR_CUST_ID',
          'MSG_STD',
          'MSG_ID',
          'MSG_VER',
          'MAP_CONV_TP',
          'FF_TYPE',
          'MAP_NAME',
          'SRM_PRCS_NO',
          'LAY_PRCS_NO',
          'FFL_PRCS_NO',
          'FFL_FILE_ID',
        ],
        data: [{}],
      },
      insertLayoutData: {
        header: [
          'SYSSTATUS',
          'ROWID',
          'SELE_YN',
          'ELEM_VAL',
          'GRP',
          'ELEM_ID',
          'CNT',
          'CODE_YN',
          'SEG_ELEM',
          'ESDATAELEM',
          'ESDATANAME',
          'EFDHTYPE',
          'EFLOOP_INDEX',
          'ESNOELEM',
          'POS',
          'EFSEGMENT_ID',
          'EFMAX_USE',
          'ESREQUIRE',
          'EFDHMAXIMUM',
          'EFLOOP_LEVEL',
          'ELEM_NO',
          'SEQ',
          'EFLOOP_ID',
          'EFCODEDEFIN',
        ],
        data: [{}],
      },
      titleRows: [
        [
          {
            fields: ['EFSEGMENT_ID'],
            title: 'Seg.',
            titleAlign: 'center',
            rowspan: 1,
            newprop: 'newprop',
          },
          { fields: ['ESDATAELEM'], title: 'Element', titleAlign: 'center', rowspan: 1 },
          { fields: ['ESDATANAME'], title: 'Element Name', titleAlign: 'center', rowspan: 1 },
          { fields: ['ESREQUIRE'], title: 'Req', titleAlign: 'center', rowspan: 1 },
          { fields: ['EFDHTYPE'], title: 'Type', titleAlign: 'center', rowspan: 1 },
          { fields: ['EFDHMAXIMUM'], title: 'Size', titleAlign: 'center', rowspan: 1 },
          { fields: ['ELEM_VAL'], title: 'Value', titleAlign: 'center', rowspan: 1 },
          { fields: ['CNT'], title: 'Count', titleAlign: 'center', rowspan: 1 },
          { fields: ['EFCODEDEFIN'], title: 'Value Info', titleAlign: 'center', rowspan: 1 },
          { fields: ['ELEM_ID'], title: 'Element Biz. ID', titleAlign: 'center', rowspan: 1 },
          { fields: ['SEG_ELEM'], title: 'MIG Name', titleAlign: 'center', rowspan: 1 },
        ],
      ],
      columns: [
        { field: 'EFSEGMENT_ID', width: 60, columnAlign: 'center' },
        { field: 'ESDATAELEM', width: 80, columnAlign: 'center' },
        { field: 'ESDATANAME', width: 180, columnAlign: 'left' },
        { field: 'ESREQUIRE', width: 60, columnAlign: 'center' },
        { field: 'EFDHTYPE', width: 60, columnAlign: 'center' },
        { field: 'EFDHMAXIMUM', width: 60, columnAlign: 'center' },
        { field: 'ELEM_VAL', width: 80, columnAlign: 'center' },
        { field: 'CNT', width: 60, columnAlign: 'center' },
        { field: 'EFCODEDEFIN', width: 210, columnAlign: 'center' },
        { field: 'ELEM_ID', width: 110, columnAlign: 'center' },
        { field: 'SEG_ELEM', width: 110, columnAlign: 'center' },
      ],
    };
  },

  computed: {
    ...mapState('srmlist', {
      ffList: 'ffList',
      genMapRes: 'genMapFlag',
    }),
    ...mapState('common', {
      darkMode: 'darkMode',
      CommMsgList: 'CommMsgList',
    }),
    ...mapState('layout', {
      segItems: 'segItems',
      segTableItems: 'segTableItems',
      layoutWindowParam: 'layoutWindowParam',
    }),
    // ...mapState("user", {
    //   getCustomerCode: "selCustomerCode",
    //   getCustomerName: "selCustomerName"
    // }),
    textColor() {
      return this.color + '--text';
    },
    maxWidth() {
      return this.size == 'min' ? 250 : 350;
    },
    headers() {
      return [
        { text: '', value: 'SELE_YN' },
        { text: 'Seg.', value: 'EFSEGMENT_ID' },
        { text: 'Element', value: 'ESDATAELEM' },
        { text: 'Element Name', value: 'ESDATANAME' },
        { text: 'Req.', value: 'ESREQUIRE' },
        { text: 'Type', value: 'EFDHTYPE' },
        { text: 'Size', value: 'EFDHMAXIMUM' },
        { text: 'Value', value: 'ELEM_VAL', filter: this.valueTypeFilter },
        { text: 'Count', value: 'CNT', filter: this.oneValueFilter },
        { text: 'Value Info.', value: 'EFCODEDEFIN', width: '100px' },
        { text: 'Element Biz. ID', value: 'ELEM_ID', filter: this.segmentFilter, width: '200px' },
        { text: 'MIG Name', value: 'SEG_ELEM', width: '100px' },
      ];
    },
  },
  watch: {
    dialog() {
      this.dialog ? this.$emit('disable-close') : this.$emit('enable-close');
    },
  },
  mounted() {
    setTimeout(() => {
      this.treeItems = msgtreeParser.parse(this.segItems)[0].children;
    }, 300);
  },
  methods: {
    queryReferenceFilesList() {
      //[2020-04-17] apply by CLV: Apply srmlist/queryMapList api
      console.log('--------- queryReferenceFilesList ----------');
      this.masterSearchItems.data[0].ADMIN_YN = 'Y';
      this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');

      // this.masterSearchItems.data[0].CUST_ID = this.getCustomerCode;
      Store.dispatch('srmlist/queryFlatFileLayoutList', this.masterSearchItems).then(() => {
        console.log('--------- Finished to process ----------');
        console.log(this.ffList);
        //console.log(JSON.stringify(this.masterItems));
      });
    },

    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },

    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },

    // selectOk() {
    //     this.$emit("select-ok", this.dataValue);
    //     this.dialog = false;
    // },
    // selectClose() {
    //   this.$emit("select-close", this.dataValue);
    //   this.dialog = false;
    // },
    // formatNumber(num) {
    //   return this.numberFormatter.format(num);
    // },
    expandAllTreeView() {
      this.expandAll = !this.expandAll;
      if (this.expandAll) {
        this.$refs.analyzedTreeView.updateAll(this.expandAll);
      } else {
        this.$set(this, 'treeItems', []);
        this.$nextTick(() => {
          this.$set(this, 'treeItems', msgtreeParser.parse(this.segItems)[0].children);
        });
      }
    },
    onChangeNotUsed() {
      console.log('onChangeNotUsed clicked !');
      this.filterQuery.qualifier = false;
    },
    async itemClick(item) {
      await this.$nextTick(() => {
        this.showLoading = true;
        this.$refs.srm_edi_analyzed_table.$forceUpdate();
      });
      await this.delay(100);
      await this.$nextTick();
      this.lazy_loading = false;
      await this.$nextTick();
      this.showLoading = false;
      setTimeout(() => {
        for (let i = 0; i < this.segTableItems.length; i++) {
          if (this.segTableItems[i].EFSEGMENT_ID === item.seg) {
            $('.analyzed-view-table .v-table-rightview-special-border').scrollTop(i * 40);
            return;
          }
        }
        alert('Item not exist in table');
      }, 300);
    },
    delay: (ms) =>
      new Promise((res) => {
        setTimeout(res, ms);
      }),

    async loadIt() {
      this.isLoading = true;

      // wait for vdom -> dom
      await this.$nextTick();

      // force browser to rerender dom
      // by requesting some property
      // from newly created node
      let width = this.$refs.hey.width;

      // wait for some time, of course
      // higher than monitor refresh rate
      await this.delay(40);

      this.isDone = true;
      this.isLoading = false;
    },
    columnCellClass(rowIndex, columnName, rowData) {
      if (rowData.ELEM_VAL != null && rowData.ELEM_VAL.toLowerCase() == 'not used') {
        return 'not-used-col';
      }
      if (columnName == 'EFSEGMENT_ID') {
        return 'seg-col';
      }
      return `${columnName}-col`;
    },
    changeView() {
      this.gridListViewBtn = !this.gridListViewBtn;
    },
    segmentFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.segmentFilterValue) {
        return true;
      }

      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.segmentFilterValue.toLowerCase());
    },
    valueTypeFilter(value) {
      let retVal = true;

      // If this filter has no value we just skip the entire filter.
      if (this.filterQuery.not_used && !this.filterQuery.qualifier) {
        return true;
      }

      if (!value) return false;

      if (!this.filterQuery.not_used) {
        if (value.toLowerCase().includes('not used')) {
          retVal = false;
        }
      }

      if (this.filterQuery.qualifier) {
        if (value.toLowerCase().includes('text')) {
          retVal = false;
        }
      }

      return retVal;
    },
    openFlatFileLayoutList() {
      let type = 'flatFileLayoutList';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('flatFileLayoutList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId };
      return { id, name, type, options };
    },
    toggleFilter(str) {
      Store.dispatch('layout/toggleValueFilter', { query: this.filterQuery });
    },
    onFilterAnalyzed(str) {
      this.showLoading = true;
      setTimeout(() => {
        Store.dispatch('layout/setFilterAnalyzed', {
          query: str,
          filterQuery: this.filterQuery,
        }).then(() => {
          this.showLoading = false;
        });
      }, 300);
    },
    getMessageData() {
      this.searchMessageItems.data[0].CUST_ID = this.params.CUST_ID;
      this.searchMessageItems.data[0].STR_SNDR = this.params.STR_SNDR;
      this.searchMessageItems.data[0].STR_RCVR = this.params.STR_RCVR;
      this.searchMessageItems.data[0].MSG_ID = this.params.MSG_ID;
      this.searchMessageItems.data[0].MSG_VER = this.params.MSG_VER;
      this.searchMessageItems.data[0].DAT_TYPE = this.params.DAT_TYPE;
      this.searchMessageItems.data[0].FR_DAT = this.params.FR_DAT;
      this.searchMessageItems.data[0].TO_DAT = this.params.TO_DAT;
      this.searchMessageItems.data[0].PRCS_STS = this.params.PRCS_STS;
      this.searchMessageItems.data[0].LAY_PRCS_NO = '';
      this.searchMessageItems.data[0].ALIAS = '';

      Store.dispatch('layout/getMessageTreeData', this.searchMessageItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.buildTreeItems();
        Store.dispatch('layout/getAnalyzedData', this.searchMessageItems).then(() => {
          this.toggleFilter();
        });
      });
    },
    buildTreeItems() {
      this.treeItems = msgtreeParser.parse(this.segItems)[0].children;
      console.log('--------- Return Result ----------');
      // console.log(JSON.stringify(this.treeItems));
    },
    getLayoutData() {
      this.searchLayoutItems.data[0].MSG_ID = this.params.MSG_ID;
      if (this.params.MSG_VER.length < 5) {
        this.searchLayoutItems.data[0].MSG_VER = 'UN' + this.params.MSG_VER;
      } else {
        this.searchLayoutItems.data[0].MSG_VER = this.params.MSG_VER;
      }
      this.searchLayoutItems.data[0].LAY_PRCS_NO = this.params.LAY_PRCS_NO;
      Store.dispatch('layout/getLayoutTreeData', this.searchLayoutItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.buildTreeItems();
        Store.dispatch('layout/getLayoutData', this.searchLayoutItems);
      });
    },
    createLayout() {
      console.log('--------- createLayout ----------');
      this.insertLayoutMaster.data[0].CUST_ID = this.params.CUST_ID;
      this.insertLayoutMaster.data[0].STR_SNDR = this.params.STR_SNDR;
      this.insertLayoutMaster.data[0].STR_RCVR = this.params.STR_RCVR;
      this.insertLayoutMaster.data[0].MSG_STD = this.params.MSG_STD;
      this.insertLayoutMaster.data[0].MSG_ID = this.params.MSG_ID;
      this.insertLayoutMaster.data[0].MSG_VER = this.params.MSG_VER;
      this.insertLayoutMaster.data[0].DAT_TYPE = this.params.DAT_TYPE;
      this.insertLayoutMaster.data[0].FR_DAT = this.params.FR_DAT;
      this.insertLayoutMaster.data[0].TO_DAT = this.params.TO_DAT;
      this.insertLayoutMaster.data[0].PRCS_STS = this.params.PRCS_STS;
      this.insertLayoutMaster.data[0].LAY_PRCS_NO = this.params.LAY_PRCS_NO;
      this.insertLayoutData.data = this.segTableItems;
      var insertPayload = [this.insertLayoutMaster, this.insertLayoutData];
      Store.dispatch('layout/createLayout', insertPayload).then(() => {
        console.log('--------- Inserted ----------');
      });
    },
    onFileChanged(e) {
      this.contenInput = e.target.files[0].name;
    },
    clickBrowse() {
      this.$refs.flatFile.click();
    },
    loadFlatFile(item) {
      this.flatFileName = item.FFL_FILE_NAME;
      this.flatFile = item;
    },
    generateMap() {
      if (this.flatFileName !== '') {
        this.isValidF = false;
      } else {
        this.isValidF = true;
      }
      if (this.mapName !== '') {
        this.isValidM = false;
      } else {
        this.isValidM = true;
        this.$refs.mapRef.focus();
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        if (
          (this.mapName !== this.dataMap ||
            this.flatFileName !== this.dataFlatFile ||
            this.mapType !== this.dataMType ||
            this.ffType !== this.dataFFType) &&
          this.isChange === 'update'
        ) {
          this.$refs.confirmDialog.dialog = true;
        } else {
          this.comfimedChange();
        }
      }
      return validResult;
    },
    comfimedChange() {
      let data = JSON.parse(JSON.stringify(this.ffList));
      let filtered = data.filter((item) => item.FFL_FILE_NAME === this.flatFileName);

      this.generateMapDataHeader.data[0].FFL_FILE_ID = filtered[0].FFL_CSV_FILE_ID;
      this.generateMapDataHeader.data[0].FFL_PRCS_NO = filtered[0].FFL_PRCS_NO;
      if (this.ffType === 'Prefix') {
        this.generateMapDataHeader.data[0].FF_TYPE = 'P';
      } else {
        this.generateMapDataHeader.data[0].FF_TYPE = 'F';
      }
      this.generateMapDataHeader.data[0].CUST_ID = this.params.CUST_ID;
      this.generateMapDataHeader.data[0].OWNR_CUST_ID = this.params.OWNR_CUST_ID;
      this.generateMapDataHeader.data[0].MSG_STD = this.params.MSG_STD;
      //this.generateMapDataHeader.data[0].MSG_ID  = this.params.MSG_ID;
      this.generateMapDataHeader.data[0].MSG_ID = this.messageType;
      this.generateMapDataHeader.data[0].MSG_VER = this.params.MSG_VER;
      this.generateMapDataHeader.data[0].LAY_PRCS_NO = this.params.LAY_PRCS_NO;
      this.generateMapDataHeader.data[0].SRM_PRCS_NO = this.params.SRM_PRCS_NO;
      this.generateMapDataHeader.data[0].MAP_CONV_TP = this.mapType;
      this.generateMapDataHeader.data[0].MAP_NAME = this.mapName;
      // console.log(JSON.stringify(this.generateMapDataHeader))
      Store.dispatch('srmlist/generateMap', this.generateMapDataHeader).then(() => {
        if (this.genMapRes === 'successful') {
          this.$refs.successDialog.dialog = true;
          console.log('--------- Inserted ----------');
        }
      });
    },
    // 203737 05/14/2021 Issue 16 New windown popup doesn't open
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
    getEDIMsgTypeList() {
      let commMsgSearchItems = {
        header: ['MSG_NM'],
        data: [
          {
            MSG_NM: '',
          },
        ],
      };
      Store.dispatch('common/getCommonMessageList', commMsgSearchItems).then(() => {
        console.log('--------- Finished to process MES ----------');
        for (let i = 0; i < this.CommMsgList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.CommMsgList[i].MSG_CD;
          EDIVerObj.value = this.CommMsgList[i].MSG_CD;
          this.EDIMesList.push(EDIVerObj);
        }
      });
    },
  },
  created() {
    console.log('--------- created abc----------');
    this.getEDIMsgTypeList();
    console.log(this.$vuetify.theme);
    console.log(this.$vuetify.theme.dark);
    this.$vuetify.theme.dark = false;
    if (window.theme) {
      this.$vuetify.theme.dark = true;
      this.checkedColor = '#38BA5C';
      this.unCheckedColor = '#292C35';
      this.toggleButton = '#292C35';
    } else {
      this.$vuetify.theme.dark = false;
      this.checkedColor = '#75C791';
      this.unCheckedColor = '#D0D4DD';
      this.toggleButton = '#FFFFFF';
    }
    this.queryReferenceFilesList();
    this.params = this.layoutWindowParam[this.$route.params.id];
    if (
      this.params.MAP_NAME &&
      this.params.FFL_FILE_NAME &&
      this.params.MAP_CONV_TP &&
      this.params.FFL_FRMT_TP
    ) {
      this.dataMap = this.params.MAP_NAME;
      this.mapName = this.dataMap;
      this.dataMType = this.params.MAP_CONV_TP;
      if (this.params.FFL_FRMT_TP === 'P') {
        this.dataFFType = 'Prefix';
      } else {
        this.dataFFType = 'FixedLength';
      }
      this.ffType = this.dataFFType;
      this.mapType = this.dataMType;
      this.dataFlatFile = this.params.FFL_FILE_NAME;
      this.flatFileName = this.dataFlatFile;
      this.isChange = 'update';
    }
    this.messageType = this.params.MSG_ID;
    this.mode = window.mode;
    if (this.params.LAY_PRCS_NO != null && this.params.LAY_PRCS_NO.length > 0) this.getLayoutData();
    else this.getMessageData();
  },
};
</script>

<style>
.analyzed-view-table {
  width: 100% !important;
  min-height: 530px;
}
.src-topTool {
  padding: 0px !important;
}
.src-topTool .col-12 {
  line-height: 30px;
}
.pd-grid-left {
  padding-bottom: 8px !important;
}
/* .fa-th-list:before {
    content: "\f00b";
    font-size: 22px;
    margin: 0px 5px;
    color: #18236D;
}
.fa-th:before {
    content: "\f00a";
    font-size: 22px;
    margin: 0px 5px;
    color: #18236D;
} */
.gridheader-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #12083f;
}
.vertical-line {
  border-left: 1px solid #18236d;
  border-bottom: 1px solid #18236d;
}
.wrap-content-left {
  height: 600px !important;
  padding: 20px 15px 15px;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
}
.wrap-content-right {
  height: 600px !important;
  padding: 20px 15px 15px;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
}
.col-tree {
  padding: 0px !important;
  margin: 0px !important;
}
/* .analyzed-dialog .tree-panel{
  background: #FAFCFF;
  border: none;
} */
.analyzed-view-dialog .analyzedTree.v-treeview {
  height: 510px !important;
  overflow-y: auto;
  max-height: 511px;
}
.btn-style {
  width: 100px !important;
  height: 30px !important;
  margin: 0px 0px 0px 10px !important;
}
.pd-height {
  padding: 0px !important;
}
.analyzed-view-table .v-table-btable .seg-col div.v-table-body-cell {
  color: #ba0070;
}
.btn-generate,
.btn-browse {
  width: 120px !important;
  height: 30px !important;
  font-weight: 500;
  font-size: 13px !important;
  line-height: 15px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.4375px;
}
.display-flex {
  display: flex;
}
.map-name,
.flatfile-layout {
  height: 30px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 5px !important;
  margin: 0px 10px;
}
.map-name {
  width: 186px;
}
.flatfile-layout {
  width: 159px;
  margin: 0px 5px 0px 10px !important;
}
.btn-bar label,
.input-content,
.map-name,
.dv-select-edi .v-select,
.dv-select-ffType .v-select {
  font-weight: 600 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  display: flex;
  align-items: center !important;
  color: #12083f !important;
}
.row-pl-16 {
  padding-left: 0px !important;
}
.btn-browse {
  min-width: 50px !important;
  width: 50px !important;
  height: 30px !important;
}
.dv-select-edi
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
  width: 54px;
  margin: 0px;
  height: 30px;
  box-sizing: border-box;
  min-height: 30px;
  box-shadow: none;
}
.theme--dark
  .dv-select-edi
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  background: #3b3e49 !important;
}
.theme--light
  .dv-select-edi
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  background: #ffffff !important;
  border: 1px solid #cedeff;
  border-radius: 3px;
}
.dv-select-ffType
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
  width: 100px;
  margin: 0px;
  height: 30px;
  box-sizing: border-box;
  min-height: 30px;
  box-sizing: border-box;
  box-shadow: none;
}
.dv-select-edi .v-text-field__details,
.dv-select-ffType .v-text-field__details {
  max-height: 0px !important;
  min-height: 0px !important;
  margin: 0px !important;
  padding: 1px 8px !important;
}
.dv-select-edi .v-input__control,
.dv-select-ffType .v-input__control {
  min-height: 30px !important;
}
.dv-select-edi .v-select__selection--comma,
.dv-select-ffType .v-select__selection--comma {
  margin: 1px 0px 1px 6px !important;
}
.dv-select-edi {
  float: right;
  margin: 0px 10px 0px 0px;
}
.dv-select-ffType {
  float: right;
  margin: 0px 5px 0px 0px;
}
.dv-select-edi .mdi-menu-down::before,
.dv-select-ffType .mdi-menu-down::before {
  content: '\F35D';
  color: #cedeff;
  font-size: 15px;
}
.dv-select-edi .v-input__icon,
.dv-select-ffType .v-input__icon {
  height: 15px !important;
  width: 15px;
  min-width: 15px !important;
}
.btn-generate .fa-magic:before {
  content: '\f0d0';
  font-size: 12px;
}
.flatfile-input .v-messages__message {
  margin-top: -2px;
}
.flatfile-input .v-input__slot {
  min-height: 30px;
  padding: 0px 10px !important;
}
.flatfile-layout-hd .v-input__slot {
  min-height: 30px;
  padding: 0px 5px 0px 10px !important;
}
.flatfile-input .v-text-field__slot {
  padding: 5px !important;
  min-height: 30px;
  height: 30px !important;
  box-sizing: border-box;
  border: none;
}
.flatfile-layout-hd .v-input__control {
  width: 175px;
}
.analyzed-dialog .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #3b3e49;
}
.analyzed-dialog
  .group-btn-hd
  .theme--dark.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background: #191a21;
}
.map-name-hd .v-input__control {
  width: 206px;
}
.group-btn-hd label {
  height: 30px;
}
/* .v-text-field.v-text-field--enclosed .v-text-field__details{
  margin-bottom: 0px !important;
} */
.input-fl.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.analyzed-view-dialog .v-btn:not(.v-btn--round).v-size--small {
  display: none;
}
.analyzed-dialog.analyzed-view-dialog .srm-info-section {
  padding: 0px !important;
}
.data-section-srm {
  padding: 0px !important;
}
.edi-analyzed-container {
  padding: 40px 40px 0px !important;
}
.analyzed-dialog .tree-container {
  padding-right: 25px;
}
.analyzed-view-dialog .data-section-srm .edi-data-mb {
  margin-bottom: 10px !important;
}
.analyzed-view-dialog .data-section-srm .v-messages {
  min-height: 22px;
}
</style>
